(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/ball-row-helper/assets/javascripts/ball-row-helper.js') >= 0) return;  svs.modules.push('/components/numbergames/ball-row-helper/assets/javascripts/ball-row-helper.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _svs$numbergames$prod = svs.numbergames.productMapping,
  getProductName = _svs$numbergames$prod.getProductName,
  getProductId = _svs$numbergames$prod.getProductId,
  isKeno = _svs$numbergames$prod.isKeno;


function getBallRowsEl(_ref) {
  let _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    beforeBallRender = _ref.beforeBallRender,
    ballRowsOptions = _ref.ballRowsOptions;
  return setupBallRowsEl({
    boards: items,
    beforeBallRender,
    BallRowsClass: svs.tur.ball.rows.Default,
    ballRowsOptions
  });
}

function getUserBoardsBallRowsEl(_ref2) {
  let _ref2$items = _ref2.items,
    items = _ref2$items === void 0 ? [] : _ref2$items,
    beforeBallRender = _ref2.beforeBallRender,
    ballRowsOptions = _ref2.ballRowsOptions;
  return setupBallRowsEl({
    boards: items,
    beforeBallRender,
    BallRowsClass: svs.tur.ball.rows.collapsible.Default,
    ballRowsOptions: _objectSpread({
      collapseAt: svs.numbergames.mybets.constants.USER_BOARDS.INIT_DISPLAY_LENGTH,
      lazyRender: true
    }, ballRowsOptions)
  });
}

function getMultiSystemRowDescription(_ref3) {
  let numbers = _ref3.numbers,
    numbersExtra = _ref3.numbersExtra,
    productId = _ref3.productId,
    participation = _ref3.participation;
  const _svs$numbergames$rule = svs.numbergames.rules[getProductId(productId)],
    numbersMaxLength = _svs$numbergames$rule.numbersMaxLength,
    _svs$numbergames$rule2 = _svs$numbergames$rule.numbersExtraMaxLength,
    numbersExtraMaxLength = _svs$numbergames$rule2 === void 0 ? 0 : _svs$numbergames$rule2;
  const numberLen = numbers.length;
  const numberExtraLen = numbersExtra === null || numbersExtra === void 0 ? void 0 : numbersExtra.length;
  let title;
  let kenoLevel;
  if (isKeno(productId)) {
    kenoLevel = participation.match(/\d/i);
    title = "System ".concat(getProductName(productId), " ").concat(kenoLevel, " | ").concat(numberLen);
  } else {
    title = "Mitt System ".concat(numberLen).concat(numberExtraLen ? " + ".concat(numberExtraLen) : '');
  }
  const numberOfRows = svs.numbergames.rules.system.generatedRows({
    numbersLength: numberLen,
    numbersExtraLength: numberExtraLen,
    numbersRowSize: kenoLevel || numbersMaxLength,
    numbersExtraRowSize: numbersExtraMaxLength
  });
  return new svs.tur.ball.row.extensions.Description({
    title: "".concat(title, ": ").concat(numberOfRows, " rader")
  });
}
function setupBallRowsEl(_ref4) {
  let boards = _ref4.boards,
    beforeBallRender = _ref4.beforeBallRender,
    BallRowsClass = _ref4.BallRowsClass,
    _ref4$ballRowsOptions = _ref4.ballRowsOptions,
    ballRowsOptions = _ref4$ballRowsOptions === void 0 ? {} : _ref4$ballRowsOptions;
  const rows = boards.map(row => {
    const numbers = row.numbers,
      extraNumbers = row.numbersExtra,
      kungKeno = row.kungKeno,
      isSystemBoard = row.isSystemBoard,
      productId = row.productId;
    const productName = getProductName(productId);
    const BallRowClass = svs.tur.ball.row[productName] || svs.tur.ball.row.Default;
    let description;
    if (isSystemBoard && boards.length > 1) {
      description = getMultiSystemRowDescription(row);
    }
    return new BallRowClass(_objectSpread({
      numbers,
      extraNumbers,
      kungKeno,
      addEmptyBall: svs.numbergames.productMapping.isKeno(productId) && !kungKeno,
      description
    }, ballRowsOptions));
  });
  const ballRows = new BallRowsClass(_objectSpread(_objectSpread({}, ballRowsOptions), {}, {
    rows
  }));
  if (typeof beforeBallRender === 'function') {
    beforeBallRender(ballRows);
  }
  return ballRows.render();
}
svs.numbergames = svs.numbergames || {};
svs.numbergames.ball_row_helper = {
  getBallRowsEl,
  getUserBoardsBallRowsEl
};

 })(window);